module.exports = __webpack_public_path__ + "static/media/newsPoint04.bb6e1a57.jpeg";